var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 471.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: .1em;\n      }\n\n      .cls-2 {\n        letter-spacing: .15em;\n      }\n\n      .cls-3 {\n        fill: url(#Gradiente_sem_nome_39);\n      }\n\n      .cls-4 {\n        letter-spacing: .08em;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-7 {\n        letter-spacing: .07em;\n      }\n\n      .cls-8 {\n        letter-spacing: .01em;\n      }\n\n      .cls-9 {\n        font-family: Glancyr-ExtraLight, Glancyr;\n        font-size: 43.54px;\n        font-variation-settings: 'wght' 250, 'ital' 0;\n        font-weight: 200;\n      }\n\n      .cls-10 {\n        letter-spacing: 0em;\n      }\n\n      .cls-11 {\n        letter-spacing: .1em;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_39",
    "data-name": "Gradiente sem nome 39",
    x1: 107.81,
    y1: 235.65,
    x2: 1180.47,
    y2: 235.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5abdd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3c9ed4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3774b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4c4294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5f328a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#873289"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 0,
    width: 2000,
    height: 471.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(1339.98 228.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "DESEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 163.68,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 194.98,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 232.56,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 258.43,
    y: 0
  }, "VIMEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 410.22,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 439.26,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 53.79
  }, "DE SOF"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 182.31,
    y: 53.79
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 212.62,
    y: 53.79
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 256.73,
    y: 53.79
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 291.04,
    y: 53.79
  }, "RE E SITES")), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M454,165.74c-2.18,2.29-4.15,5.94-5.89,10.95-1.76-5.01-3.7-8.66-5.89-10.95-2.18-2.29-5.78-4.18-10.79-5.73,5.01-1.73,8.6-3.75,10.79-6.04,2.18-2.29,4.13-5.94,5.89-10.95,1.73,5.01,3.7,8.66,5.89,10.95,2.18,2.29,5.78,4.31,10.79,6.04-5.01,1.54-8.6,3.44-10.79,5.73ZM276.12,209.72c0-34.31-27.91-62.23-62.23-62.23h-94.11c-6.6,0-11.97,5.37-11.97,11.97v50.26c0,34.31,27.91,62.23,62.23,62.23h43.85c34.31,0,62.23-27.91,62.23-62.23ZM213.89,166.14c24.03,0,43.58,19.55,43.58,43.58s-19.55,43.58-43.58,43.58h-43.85c-24.03,0-43.58-19.55-43.58-43.58v-43.58h87.44ZM276.12,271.99c0-34.31-27.91-62.23-62.23-62.23h-43.85c-34.31,0-62.23,27.91-62.23,62.23v50.26c0,6.6,5.37,11.97,11.97,11.97h94.11c34.31,0,62.23-27.91,62.23-62.23ZM126.45,271.99c0-24.03,19.55-43.58,43.58-43.58h43.85c24.03,0,43.58,19.55,43.58,43.58s-19.55,43.58-43.58,43.58h-87.44v-43.58ZM324.81,333.83v-133.57h-24.84v133.57h24.84ZM416.98,254.22c0-9.62-1.03-18.03-3.07-25.25-2.05-7.21-5.17-13.22-9.35-18.03-4.19-4.81-9.35-8.46-15.49-10.95-6.14-2.49-13.4-3.74-21.77-3.74-9.26,0-17.23,1.69-23.91,5.08-6.68,3.39-12.16,8.19-16.43,14.43-4.27,6.24-7.39,13.72-9.35,22.44-1.96,8.73-2.94,18.35-2.94,28.85v2.67h10.15v-2.94c0-15.49,3.34-27.2,10.02-35.13,6.68-7.92,15.9-11.89,27.65-11.89,5.88,0,10.82.85,14.83,2.54,4.01,1.69,7.21,4.05,9.62,7.08,2.4,3.03,4.14,6.64,5.21,10.82,1.07,4.19,1.6,8.86,1.6,14.03h23.24ZM435.68,333.83h24.84v-133.57h-24.84v133.57ZM512.08,333.83v-200.36h-24.84v200.36h24.84ZM563.63,333.83v-200.36h-24.84v200.36h24.84ZM672.36,333.83v-75.07c0-10.86-1.16-20.26-3.47-28.18-2.32-7.92-5.92-14.43-10.82-19.5-4.9-5.08-11.04-8.82-18.43-11.22-7.39-2.4-16.16-3.61-26.31-3.61-11.4,0-20.97,1.69-28.72,5.08-7.75,3.39-13.94,8.19-18.57,14.43-4.63,6.24-7.88,13.72-9.75,22.44-1.87,8.73-2.81,18.35-2.81,28.85v2.67h10.15v-2.94c0-15.49,3.69-27.2,11.09-35.13,7.39-7.92,18.3-11.89,32.73-11.89,8.19,0,14.87.98,20.04,2.94,5.16,1.96,9.22,4.72,12.15,8.28,2.94,3.56,4.98,7.79,6.14,12.69,1.16,4.9,1.74,10.46,1.74,16.7v73.46h24.84ZM691.06,267.04c0,11.58,1.69,21.77,5.08,30.59,3.38,8.82,8.01,16.21,13.89,22.17,5.88,5.97,12.82,10.46,20.84,13.49,8.01,3.03,16.65,4.54,25.91,4.54,11.93,0,21.59-1.92,28.98-5.74,7.39-3.83,13.13-8.95,17.23-15.36,4.09-6.41,6.85-13.89,8.28-22.44,1.42-8.55,2.14-17.63,2.14-27.25,0-10.69-.8-20.39-2.4-29.12-1.6-8.72-4.54-16.16-8.82-22.31-4.27-6.14-10.11-10.91-17.5-14.29-7.39-3.38-17.06-5.08-28.98-5.08-20.48,0-36.38,5.97-47.69,17.9-11.31,11.93-16.96,29.57-16.96,52.89ZM717.24,266.77c0-7.66.76-14.43,2.27-20.3,1.51-5.88,3.96-10.77,7.35-14.69,3.38-3.92,7.83-6.9,13.36-8.95,5.52-2.05,12.38-3.07,20.57-3.07,14.78,0,25.87,3.97,33.26,11.89,7.39,7.93,11.09,19.64,11.09,35.13s-3.7,27.52-11.09,35.53c-7.39,8.01-18.48,12.02-33.26,12.02s-25.29-4.01-32.59-12.02c-7.31-8.01-10.95-19.86-10.95-35.53ZM805.13,333.83h24.84v-133.57h-24.84v133.57ZM881.53,333.83v-133.57h-24.84v133.57h24.84ZM990.26,333.83v-75.07c0-10.86-1.16-20.26-3.47-28.18-2.32-7.92-5.92-14.43-10.82-19.5-4.9-5.08-11.04-8.82-18.43-11.22-7.39-2.4-16.16-3.61-26.31-3.61-11.4,0-20.97,1.69-28.72,5.08-7.75,3.39-13.94,8.19-18.57,14.43-4.63,6.24-7.88,13.72-9.75,22.44-1.87,8.73-2.81,18.35-2.81,28.85v2.67h10.15v-2.94c0-15.49,3.69-27.2,11.09-35.13,7.39-7.92,18.3-11.89,32.73-11.89,8.19,0,14.87.98,20.04,2.94,5.16,1.96,9.22,4.72,12.15,8.28,2.94,3.56,4.98,7.79,6.14,12.69,1.16,4.9,1.74,10.46,1.74,16.7v73.46h24.84ZM986.26,170.87h150.4v-24.04h-150.4v24.04ZM1048.5,333.83h25.91v-187h-25.91v187ZM1154.55,333.83h25.91v-187h-25.91v187Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1261.12,
    y1: 176.7,
    x2: 1261.12,
    y2: 300.78
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.401adc3af5bbd96ac159dcecb4f03824.svg";
export { ForwardRef as ReactComponent };